import { IIdentifiable } from '@/common/models/models'

interface IHot17Entry extends IIdentifiable {
    song: string
    votes_count: number
}

class Hot17Entry implements IHot17Entry {
    id = 0
    song = ''
    votes_count = 0

    position = 0
    percentage = 0

    constructor (dto?: IHot17Entry) {
        if (dto) {
            this.id = dto.id
            this.song = dto.song
            this.votes_count = dto.votes_count
        }
    }

    get percentageString (): string {
        return isNaN(this.percentage) ? '0%' : `${this.percentage.toFixed(2)}%`
    }
}

export {
    IHot17Entry, Hot17Entry
}
